class UserDisplay {
    constructor($scope, userPopupService) {
        'ngInject';
        this.userPopupService = userPopupService;
    }

    $onInit() {
        this.fontSize = this.fontSize || 14;
        this.avatarSize = this.avatarSize || 18;
        this.hasLink = this.hasLink === undefined && (this.user && ((this.user.id != null && this.user.id !== 1) || (this.user.Id != null && this.user.Id !== 1) )); // no link for system user
    }

    click() {
        if (this.hasLink) {
            if (this.modalOpened) {
                this.modalOpened();
            }
            this.userPopupService.openUserInProject({
                userId: this.user.Id || this.user.id,
                projectId: ttb.constants.routing.PROJECT_ID
            }, this.containerSelector ? $(this.containerSelector) : undefined);
        }
    }

    showUnassigned() {
        return !this.avatarOnly && !this.hasUser();
    }

    getName() {
        return this.user ? this.user.FormattedFullName || this.user.formattedFullName || this.user.title : "";
    }

    getAvatarUrl() {
        return this.user ? this.user.AvatarUrl || this.user.avatarUrl || this.user.avatar : "";
    }

    hasUser() {
        return this.user && (this.user.Id || this.user.id);
    }
}

export default UserDisplay;



// WEBPACK FOOTER //
// ../widgets/user-display/user-display.controller.js